var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-screen bg-gray-200 sys-app-notCollapsed font-sans flex min-h-screen w-full"},[_c('nav-bar',{staticClass:"w-64 p-4"}),_c('router-view',{staticClass:"w-full p-4 overflow-x-hidden"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }